import { SCOPE_SPECIFICITY } from "./content.js";
import { publicAnnouncementSchema, publicPromotionSchema, publicSponsoredSchema } from "./public-api.js";
/** CMS resolution levels. Local portal fallback is outside the CMS resolver. */
export const RESOLUTION_LEVELS = ["emergency", "site", "site_group", "tenant_global"];
export function scopeToResolutionLevel(scope, isEmergency = false) {
    if (isEmergency)
        return "emergency";
    if (scope === "global")
        return "tenant_global";
    return scope;
}
export function buildPublicAnnouncement(input) {
    return publicAnnouncementSchema.parse({
        type: input.severity,
        title: input.title,
        body: input.body,
        dismissible: input.dismissible,
        startsAt: input.startsAt ? input.startsAt.toISOString() : null,
        endsAt: input.endsAt ? input.endsAt.toISOString() : null,
    });
}
function sortByPriorityTimeId(candidates) {
    return [...candidates].sort((a, b) => {
        if (b.priority !== a.priority)
            return b.priority - a.priority;
        const timeDiff = b.publishedAt.getTime() - a.publishedAt.getTime();
        if (timeDiff !== 0)
            return timeDiff;
        if (a.id === b.id)
            return 0;
        return a.id < b.id ? 1 : -1;
    });
}
function selectContentCandidate(candidates) {
    if (candidates.length === 0)
        return null;
    let bestLevel = 0;
    for (const c of candidates) {
        bestLevel = Math.max(bestLevel, SCOPE_SPECIFICITY[c.scope]);
    }
    const atLevel = candidates.filter((c) => SCOPE_SPECIFICITY[c.scope] === bestLevel);
    return sortByPriorityTimeId(atLevel)[0] ?? null;
}
export function selectAnnouncementForSite(candidates) {
    if (candidates.length === 0)
        return null;
    const emergencies = candidates.filter((c) => c.isEmergency);
    if (emergencies.length > 0) {
        return sortByPriorityTimeId(emergencies)[0] ?? null;
    }
    return selectContentCandidate(candidates);
}
export function selectPromotionForSite(candidates) {
    return selectContentCandidate(candidates);
}
/** Within a targeting level: priority → publishedAt → stable id (same as content). */
export function selectSponsoredForSite(candidates) {
    return selectContentCandidate(candidates);
}
export function buildPublicSponsored(input) {
    return publicSponsoredSchema.parse({
        advertiserName: input.advertiserName,
        sponsorshipLabel: input.sponsorshipLabel,
        headline: input.headline,
        description: input.description,
        offerText: input.offerText ?? null,
        imagePath: input.imagePath,
        imageAlt: input.imageAlt,
        ctaLabel: input.ctaLabel,
        ctaHref: input.ctaHref,
        startsAt: input.startsAt.toISOString(),
        endsAt: input.endsAt.toISOString(),
    });
}
export function buildPublicPromotion(input) {
    const hasCta = input.ctaType !== null && input.ctaHref !== null;
    return publicPromotionSchema.parse({
        title: input.title,
        body: input.body,
        badge: input.badge ?? "",
        ctaLabel: hasCta ? input.ctaLabel : "",
        ctaHref: hasCta ? input.ctaHref : null,
        imagePath: input.imagePath ?? null,
        imageAlt: input.imageAlt ?? "",
        startsAt: input.startsAt ? input.startsAt.toISOString() : null,
        endsAt: input.endsAt ? input.endsAt.toISOString() : null,
    });
}
//# sourceMappingURL=portal-selection.js.map